import { navigateMediaItem } from '@/helpers/navigateMediaItem';
import { closeModal } from '@/helpers/closeModal';
import { commonChangeMediaProcess, setImageTimer } from '@/helpers/mediaUtils';
import { updateCtaButtonAction } from '@/modules/actions/mobile/updateCtaButtonAction';
import { animateCurrentProgressBar } from '@/modules/actions/headerLineDuration';
import { getSwiperInstance } from '@/helpers/swiperInstance';

let previousMovie = null;

export const mobileAutoPlayNextAction = () => {
  let movie;
  if  (window.storeeelItems.frame === "circle") {
    movie = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .storeeel-movie.active');
  } else {
    movie = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper .storeeel-movie');
  }

  if (movie) {
    if (movie !== previousMovie) {
      // 前の動画のイベントを解除
      if (previousMovie && previousMovie._endedListener) {
        previousMovie.removeEventListener("ended", previousMovie._endedListener);
      }

      // 新しい動画にイベントを追加
      const onEnded = () => {
        commponProcess();
      };

      movie.addEventListener("ended", onEnded);
      movie._endedListener = onEnded;
      previousMovie = movie;
    }
  }

  // 画像の自動再生
  mobileAutoPlayNextImageAction();
};

export const mobileAutoPlayNextImageAction = () => {
  let image;
  if (window.storeeelItems.frame === "circle") {
    image = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper .storeeel-media-image.active');
  } else {
    image = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper .storeeel-media-image');
  }
  if (image) {
    setImageTimer(() => {
      commponProcess();
    }, 5000);
  }
}

function commponProcess() {
  const swiper = getSwiperInstance();
  // 次の動画を再生
  window.moviePosition += 1;
  const contents = navigateMediaItem();
  if (!contents) {
    return closeModal();
  }
  if (window.moviePosition != 0) {
    commonChangeMediaProcess(contents);
  } else {
    swiper.slideNext();
  }

  // 進捗バーのためのインデックスを計算
  let groupIndex = window.storeeelItems.contentGroups.findIndex(group => group.id === window.iconId);
  let progressIndex = 0;
  if (groupIndex == 0) {
    progressIndex = window.moviePosition;
  } else {
    for (let i = 0; i < groupIndex; i++) {
      progressIndex += window.storeeelItems.contentGroups[i].contents.length;
    }
    progressIndex += window.moviePosition;
  }
  // 進捗バーのアニメーションを開始
  const video = document.querySelector('.storeeel-swiper-group-wrapper  .swiper-slide-active .slide-media-wrapper video');
  if (video) {
    video.addEventListener('loadedmetadata', () => {
      animateCurrentProgressBar(video.duration, progressIndex);
    });
  }
  const image = document.querySelector('.storeeel-swiper-group-wrapper  .swiper-slide-active .slide-media-wrapper img');
  if (image) {
    animateCurrentProgressBar(5, progressIndex);
  }

  const allSlides = document.querySelectorAll('.storeeel-swiper-group-wrapper  .swiper-slide');
  const currentSlide = allSlides[swiper.activeIndex];
  const slideMediaWrapper = currentSlide.querySelector('.slide-media-wrapper');
  // CTAボタンの更新
  updateCtaButtonAction(slideMediaWrapper)

  // 自動再生の設定
  mobileAutoPlayNextAction();
}
